import React from 'react'
import PropTypes from 'prop-types'
import {Eyebrow as HecEyebrow} from '@/components/ui/eyebrow'

const Eyebrow = ({content, size, attributes}) => {
    return (
        <HecEyebrow size={size} {...attributes} data-testid="eyebrow-HecEyebrow">
            {content}
        </HecEyebrow>
    )
}

export default Eyebrow

Eyebrow.propTypes = {
    content: PropTypes.string.isRequired,
    size: PropTypes.string.isRequired,
    attributes: PropTypes.object
}

export const EyebrowDefinition = {
    component: Eyebrow,
    name: 'Eyebrow',
    noWrap: true,
    inputs: [
        {
            name: 'tag',
            type: 'string',
            enum: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'div', 'span', 'p'],
            defaultValue: 'span'
        },
        {
            name: 'size',
            type: 'string',
            enum: ['large', 'small'],
            defaultValue: 'large'
        },
        {
            name: 'content',
            type: 'string',
            defaultValue: 'Eyebrow'
        }
    ]
}
